// extracted by mini-css-extract-plugin
export default {"container":"Sneak_container__O33mp","wrapper":"Sneak_wrapper__YiqDP","detail":"Sneak_detail__w5UV8"};